import React from 'react';
import {feedbackText} from '../feedbackText';
import editorStyles from '../../Microreels/List/components/MicroreelQuestionEditor.module.css';
import styles from './FeedbackPhonePreview.module.css';

interface Props {
  title: string;
  question: string;
  answers: string[];
  selectedIndex?: number;
}

const FeedbackPhonePreview = ({
  title,
  question,
  answers,
  selectedIndex,
}: Props) => {
  const withPlaceholder = (value: string, placeholder: string) =>
    value.trim() ? (
      value
    ) : (
      <span className={styles.placeholder}>{placeholder}</span>
    );

  return (
    <div className={editorStyles.phoneFrame}>
      <div className={`${editorStyles.phoneScreen} ${styles.phoneScreen}`}>
        <div className={styles.phoneCard}>
          <p className={styles.phoneLabel}>
            {withPlaceholder(title, feedbackText.titlePlaceholder)}
          </p>
          <p className={styles.phoneQuestion}>
            {withPlaceholder(question, feedbackText.questionPlaceholder)}
          </p>
          <p className={styles.phoneSelectHint}>
            {feedbackText.phoneSelectHint}
          </p>
          <div className={styles.phoneOptions}>
            {answers.map((answer, index) => (
              <div
                key={index}
                className={`${styles.phoneOption} ${
                  index === selectedIndex ? styles.phoneOptionSelected : ''
                }`}>
                <span className={styles.phoneRadio} />
                <span className={styles.phoneOptionText}>
                  {withPlaceholder(answer, feedbackText.answerPlaceholder)}
                </span>
              </div>
            ))}
          </div>
          <div className={styles.phoneActions}>
            <span className={styles.phoneNotNow}>
              {feedbackText.phoneNotNow}
            </span>
            <span className={styles.phoneSubmit}>
              {feedbackText.phoneSubmit}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedbackPhonePreview;
